export function createLog(group, topic, data) {
  return {
    group,
    topic,
    data,
    timestamp: Date.now(),
    repeated: 0,
  };
}